const AgentsFactoryActionTypes = {
  AGENTS_FACTORY_SIGNUP_REQUEST: 'AGENTS_FACTORY_SIGNUP_REQUEST',
  AGENTS_FACTORY_SIGNUP_SUCCESS: 'AGENTS_FACTORY_SIGNUP_SUCCESS',
  AGENTS_FACTORY_SIGNUP_FAILURE: 'AGENTS_FACTORY_SIGNUP_FAILURE',
};

export { AgentsFactoryActionTypes };
